<label
	*ngIf="control"
	class="c-checkbox"
	[class.c-checkbox--active]="isActive()"
	[class.c-checkbox--inter]="isInter()"
	[class.c-checkbox--error]="hasError()"
	[class.c-checkbox--green]="theme === 'green'"
	[class.c-checkbox--disabled]="control.disabled"
	[class.c-checkbox--radio]="radio"
>
	<input type="checkbox" [formControl]="control" />

	<div class="c-checkbox__checkmark">
		<tvcore-icon name="checkmark"></tvcore-icon>
		<tvcore-icon name="line"></tvcore-icon>
	</div>

	<span [class.bg-inherit]="bgInherit">
		<ng-content></ng-content>
	</span>
</label>
